import type { FormInstance } from '@arco-design/web-react';

import type { ResourceFormContextValue } from './context';

/** 按 FormInstance 绑定 ResourceFormContext，供 linkage effect 等非 React 路径读取下单模式 */
const registry = new WeakMap<object, ResourceFormContextValue>();

export function registerResourceFormContext(form: FormInstance, value: ResourceFormContextValue | null | undefined) {
  if (!value) {
    registry.delete(form);
    return;
  }
  registry.set(form, value);
}

export function peekResourceFormContext(form: FormInstance): ResourceFormContextValue | undefined {
  return registry.get(form);
}

export function isOrderResourceEditMode(form: FormInstance): boolean {
  const mode = peekResourceFormContext(form)?.resourceEditMode;
  return mode === 'order-fixed' || mode === 'order-custom' || mode === 'order-post-paid';
}
